import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ImageTypeContainer from './imageType/ImageTypeContainer';
import CustomImageContainer from './customImage/CustomImageContainer';
import { AppStateTypes } from '../../store/appStateTypes';
import { setItem } from '../../helpers/localStorage';
import { LOCAL_STORAGE_IMAGE_SETTINGS } from '../../constants/localStorageConstants';

const ImageSettingsContainer = () => {
  const imageSettings = useSelector((state: AppStateTypes) => state.imageSettings);

  useEffect(() => {
    setItem(LOCAL_STORAGE_IMAGE_SETTINGS, imageSettings);
  }, [imageSettings]);

  return (
        <>
            <ImageTypeContainer />
            <CustomImageContainer />
        </>
  );
};

export default ImageSettingsContainer;
